module.exports = __webpack_public_path__ + "static/media/Basal_4310.98761ecc.jpg";